import React from "react";
import thumbnail from "../../../../Assets/Images/Services/webDevelopment.png";
const CourseLessonLeft = ({ video }) => {
  return (
    <div>
      <div>
        <video
          poster={thumbnail}
          src={`https://server.globalitmaster.com/${video}`}
          type="video/mp4"
          height="400px"
          controls
        ></video>
      </div>
      <div className="border-b-[2px] border-[#ffffff] pt-5 pb-2 ">
        <h3 className="text-lg font-semibold">HTML Introduction </h3>
        <h5 className="text-base text-[#2c2c2c] mt-5">ওভারভিউ</h5>
      </div>
    </div>
  );
};

export default CourseLessonLeft;
